import { UPDATE_NEWCHECKOUT_STATE } from './newCheckout.types';

export interface NewCheckoutState {
  newCheckoutFlow: boolean | null; // safety check for new flow;
  newUserData: any | null;
}

export const initialNewCheckoutState: NewCheckoutState = {
  newCheckoutFlow: true,
  newUserData: null,
};

const newCheckoutReducer = (state = initialNewCheckoutState, action: any) => {
  switch (action.type) {
    case UPDATE_NEWCHECKOUT_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state ? state : initialNewCheckoutState;
  }
};

export default newCheckoutReducer;
